/**
 * 名前空間 `notifications` — 通知ドロワーの行 (集約した文・日付見出し・種類・面) と新着ポップアップ。
 * ドロワーの枠は `shell.notifications`。文言は `locales/ja/notifications.ts` (正本) と
 * `locales/en/notifications.ts`。utils (`notificationFormat` など) も日本語をここから描く。
 */
import { defineNamespace } from '../registry';
import { notificationsEn } from '../locales/en/notifications';
import { notificationsJa } from '../locales/ja/notifications';

export const notificationsNs = defineNamespace('notifications', notificationsJa, notificationsEn);
